<template>
  <div class="ag-studio-tab ag-knowledge">
    <SnackbarComp :SnackbarComponent="snackbar" />

    <div class="ag-knowledge__workspace">
      <KnowledgeBaseTab
        ref="knowledgeTabRef"
        :active="active"
        embedded
        @saved="onKnowledgeBaseSaved"
        @edit-dialog-change="onEditDialogChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import SnackbarComp from '@/components/Extras/SnackbarComp.vue'
import KnowledgeBaseTab from '@/components/Organizations/Tabs/KnowledgeBaseTab.vue'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'
import { loadOrgDetailsIntoStore } from '@/utils/orgDetailsLoader'
import { useStore } from 'vuex'

defineOptions({ name: 'AgentKnowledgeStudio' })

const props = defineProps({
  active: { type: Boolean, default: false },
  showTrainDialog: { type: Boolean, default: false },
})

const emit = defineEmits(['update:showTrainDialog'])

const store = useStore()
const snackbar = ref({})
const knowledgeTabRef = ref(null)

watch(
  () => props.showTrainDialog,
  (open) => {
    if (open) {
      knowledgeTabRef.value?.openEditDialog?.()
    }
  },
)

watch(
  () => props.active,
  (isActive) => {
    if (isActive) void refreshOrgDetails()
  },
)

async function refreshOrgDetails() {
  await loadOrgDetailsIntoStore(store)
}

function onEditDialogChange(open) {
  if (!open && props.showTrainDialog) {
    emit('update:showTrainDialog', false)
  }
}

async function onKnowledgeBaseSaved() {
  emit('update:showTrainDialog', false)
  try {
    await refreshOrgDetails()
    await knowledgeTabRef.value?.refreshAfterKnowledgeBaseSave?.()
    snackbar.value = {
      SnackbarVmodel: true,
      SnackbarColor: 'success',
      SnackbarText: 'Knowledge base updated successfully.',
    }
  } catch (err) {
    snackbar.value = {
      SnackbarVmodel: true,
      SnackbarColor: 'warning',
      SnackbarText: getApiMessage(err, 'Saved, but failed to refresh knowledge base.'),
    }
  }
}
</script>
